import { Navigate, useLocation } from 'react-router-dom';
import type { PropsWithChildren } from 'react';
import { useAuth } from '../hooks/useAuth';

const AdminRoute = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const isStaff = Boolean(user?.isStaff ?? user?.is_staff);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isStaff) {
    return <Navigate to="/app/reports" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
